import type { ButtonProps } from '@mui/material/Button';

import Button from '@mui/material/Button';
import styled from '@emotion/styled';
import { PaperColorElevation } from '../PaperColorElevation';

// type arrowOptions = {
//   arrowOptions?: 'default' | 'circular';
// }

export const Arrow = styled(Button)<ButtonProps>(({ theme }) => ({
  position: 'absolute',
  zIndex: 1,
  top: 'calc(50% - 30px)',
  width: theme.theme_component_list_arrow_width ? `${theme.theme_component_list_arrow_width}px` : '40px',
  minWidth: theme.theme_component_list_arrow_min_width ? `${theme.theme_component_list_arrow_min_width}px` : '40px',
  height: theme.theme_component_list_arrow_height ? `${theme.theme_component_list_arrow_height}px` : 'auto',
  minHeight: theme.theme_component_list_arrow_minimum_height
    ? `${theme.theme_component_list_arrow_minimum_height}px`
    : 'auto',
  backgroundColor: theme.theme_component_list_arrow_background_color || theme.palette.secondary.main,
  '& svg': {
    color: theme.theme_component_list_arrow_svg_color || theme.palette.common.white,
  },
  hover: {
    backgroundColor: theme.theme_component_list_arrow_hover_background_color,
  },
  '&.swiper-button-disabled': {
    filter: 'grayscale(1)',
    cursor: 'default',
  },
}));

export const ArrowLeft = styled(Arrow)(({ theme }) => ({
  left: theme.theme_component_list_arrow_left_left ? `${theme.theme_component_list_arrow_left_left}px` : 0,
  borderRadius:
    theme.theme_component_list_arrow_left_border_radius ||
    `0 ${theme.shape.borderRadius}px ${theme.shape.borderRadius}px 0`,
  '& svg': {
    marginLeft: theme.theme_component_list_arrow_left_svg_margin_left
      ? `${theme.theme_component_list_arrow_left_svg_margin_left}px`
      : theme.spacing(1),
    fontSize: theme.theme_component_list_arrow_left_svg_font_size
      ? `${theme.theme_component_list_arrow_left_svg_font_size}px`
      : undefined,
  },
}));

export const ArrowRight = styled(Arrow)(({ theme }) => ({
  right: theme.theme_component_list_arrow_right_right ? `${theme.theme_component_list_arrow_right_right}px` : 0,
  borderRadius:
    theme.theme_component_list_arrow_right_border_radius ||
    `${theme.shape.borderRadius}px 0 0 ${theme.shape.borderRadius}px`,
  '& svg': {
    marginRight: theme.theme_component_list_arrow_right_svg_margin_right
      ? `${theme.theme_component_list_arrow_right_svg_margin_right}px`
      : theme.spacing(1),
    fontSize: theme.theme_component_list_arrow_right_svg_font_size
      ? `${theme.theme_component_list_arrow_right_svg_font_size}px`
      : undefined,
    transform: 'rotate(180deg)',
  },
}));

export const ArrowUp = styled(Arrow)(({ theme }) => ({
  top: '12px',
  left: 0,
  right: 0,
  margin: 'auto',
  borderRadius:
    theme.theme_component_list_arrow_left_border_radius ||
    `0 ${theme.shape.borderRadius}px ${theme.shape.borderRadius}px 0`,
  '& svg': {
    fontSize: theme.theme_component_list_arrow_left_svg_font_size
      ? `${theme.theme_component_list_arrow_left_svg_font_size}px`
      : undefined,
  },
}));

export const ArrowDown = styled(Arrow)(({ theme }) => ({
  bottom: 0,
  left: 0,
  right: 0,
  margin: '320px auto',
  marginBottom: 0,
  borderRadius:
    theme.theme_component_list_arrow_right_border_radius ||
    `${theme.shape.borderRadius}px 0 0 ${theme.shape.borderRadius}px`,
  '& svg': {
    fontSize: theme.theme_component_list_arrow_right_svg_font_size
      ? `${theme.theme_component_list_arrow_right_svg_font_size}px`
      : undefined,
  },
}));

export const CardSkeletonStyled = styled(PaperColorElevation)<{ width: number; height: number }>(
  ({ theme, width, height }) => ({
    boxShadow: theme.shadows[0],
    aspectRatio: `${width}/${height}`,
  })
);

interface CarouselListContainerProps {
  vertical: boolean;
}

export const CarouselListContainer = styled('div')(({ vertical }: CarouselListContainerProps) => ({
  height: vertical ? 'inherit' : '100%',
  maxHeight: '100vw',
  minHeight: 0,
  minWidth: 0,
  maxWidth: '100vw',
  width: '100%',
  overflow: 'hidden',
  '.swiper > .swiper-wrapper': {
    maxHeight: '100%',
    height: vertical ? '628px' : '100%',
    display: 'flex',
  },
  '.swiper > .swiper-slide': {
    width: 'auto',
    flexShrink: 0,
    display: 'block',
    height: '100%',
    maxHeight: '100%',
  },
}));

export const TrendSticker = styled.span`
  position: absolute;
  top: 24px;
  background-color: #f9484a;
  background-image: linear-gradient(315deg, #f9484a 0%, #fbd72b 74%);
  color: yellow;
  padding: 4px 8px;
  border-radius: 0px 0px 8px 0px;
`;
